import React from 'react'
import ColumnInfoTooltip from 'core/elements/tooltip/ColumnInfoTooltip'

type EntityType = 'image' | 'VM snapshot'

interface ImageStatusInfoProps {
  entityType?: EntityType
}

const getStatuses = (entityType: EntityType) => [
  {
    name: 'active',
    description: `The ${entityType} is active and ready for consumption in the Image service.`,
  },
  {
    name: 'queued',
    description: `The Image service reserved an ID for the ${entityType} in the catalog but did not yet upload any data.`,
  },
  {
    name: 'deleted',
    description: `The Image service retains information about the ${entityType} but it is no longer available for use.`,
  },
  {
    name: 'uploading',
    description: `Data has been staged as part of the interoperable ${entityType} import process. It is not yet available for use.`,
  },
  {
    name: 'importing',
    description: `The ${entityType} data is being processed as part of the interoperable ${entityType} import process, but is not yet available for use.`,
  },
  {
    name: 'saving',
    description: `The Image service is in the process of saving the raw data for the ${entityType} into the backing store.`,
  },
]

const ImageStatusInfo: React.FC<ImageStatusInfoProps> = ({ entityType = 'image' }) => {
  const statuses = getStatuses(entityType)
  return <ColumnInfoTooltip statuses={statuses} />
}

export default ImageStatusInfo
